import type { BlockStateDefinition } from '@unifyapps/carbon/no-code/components/BlockDefinition';
import type { BlockType, ComponentTypeUnionType } from '@unifyapps/defs/types/block';
import type { AlertComponentType } from '@unifyapps/defs/blocks/Alert/types';
import _pick from 'lodash/pick';
import { lazy } from 'react';

const importAvatarComponent = () =>
  import(
    /* webpackChunkName: "avatar-block" */
    './Avatar'
  );

const Avatar = lazy(importAvatarComponent);

class AvatarBlockStateDefinition implements BlockStateDefinition {
  getComponent() {
    return Avatar;
  }

  get type(): ComponentTypeUnionType {
    return 'Avatar';
  }

  get initialStateGetter() {
    return (block: BlockType) => ({
      id: block.id,
      ..._pick(block.component as AlertComponentType, ['content', 'appearance', 'componentType']),
    });
  }

  preload() {
    return {
      blockPreload: importAvatarComponent,
    };
  }
}

export default AvatarBlockStateDefinition;
